module.exports = __webpack_public_path__ + "img/executor.57c8eba8.svg";